import { SxProps } from '@mui/material'

export const containerStyle: SxProps = {
  display: 'flex',
  justifyContent: 'center'
}

export const contentBoxStyle: SxProps = {
  maxWidth: '1040px',
  width: '100%'
}

export const titleBoxStyle: SxProps = {
  textAlign: 'center',
  paddingTop: '36px'
}

export const listContainerStyle: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  pt: { xs: '136px', md: '113px' }
}

export const listStyle: SxProps = {
  width: { xs: '100%', md: '1040px' }
}

export const newButtonContainerStyle: SxProps = {
  width: '100%'
}

export const newButtonStyle: SxProps = {
  padding: '36px 0px'
}

export const buttonGridStyle: SxProps = {
  display: 'flex',
  flexDirection: 'column'
}

export const primaryTextStyle: SxProps = {
  fontSize: { xs: '19px', md: '20px' },
  lineHeight: { xs: '23px', md: '24px' },
  fontWeight: 500,
  mb: '8px'
}

export const listItemButtonStyle: SxProps = {
  padding: { xs: '30px 24px', md: '36px 0px' }
}

export const contentGridExtendedStyle: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  width: 'calc(100% - 36px)'
}

export const titleTextStyle: SxProps = {
  textAlign: 'start',
  fontSize: { xs: '19px', md: '20px' },
  lineHeight: { xs: '23px', md: '24px' },
  fontWeight: 500,
  width: '100%',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  mb: '8px'
}

export const dateTimeTextStyle: SxProps = {
  textAlign: 'start',
  fontSize: { xs: '14px', md: '16px', lineHeight: '16px' }
}

export const arrowIconStyle: SxProps = {
  minWidth: '24px',
  height: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginInlineStart: '12px'
}

export const fullWidthStyle: SxProps = {
  width: '100%'
}

export const loadingContainerStyle: SxProps = {
  width: '100%'
}

export const loadingItemStyle: SxProps = {
  height: '75px',
  justifyContent: 'center'
}

export const titleTypographyStyle: SxProps = {
  fontWeight: '500',
  fontSize: { xs: '36px', md: '48px' }
}

export const detailContainerStyle: SxProps = {
  display: 'flex',
  justifyContent: 'center'
}

export const detailContentBoxStyle: SxProps = {
  width: { xs: '100%', md: '1040px' }
}

export const detailTitleBoxStyle: SxProps = {
  textAlign: 'center',
  paddingTop: '36px',
  paddingX: { xs: '24px', md: '0' },
  wordBreak: 'keep-all'
}

export const detailTitleTypographyStyle: SxProps = {
  fontWeight: '500',
  fontSize: { xs: '36px', md: '48px' },
  textAlign: 'center',
  textOverflow: 'ellipsis',
  width: '100%',
  overflow: 'hidden'
}

export const detailInfoBoxStyle: SxProps = {
  marginTop: '40px',
  paddingX: { xs: '24px', md: '0' }
}

export const detailInfoStackStyle: SxProps = {
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: { xs: 'start', md: 'center' },
  justifyContent: 'flex-start',
  spacing: 1,
  width: '100%',
  marginBottom: '15px'
}

export const detailDateTextStyle: SxProps = {
  fontSize: '16px'
}

export const detailDescriptionStyle = (theme: any): SxProps => ({
  color: theme.palette.mode === 'dark' ? '#fefefe' : '#010101',
  fontSize: { xs: '15px', md: '16px' },
  letterSpacing: '0px',
  wordBreak: 'break-word'
})
